/* eslint-disable import-x/no-commonjs */
/*
 * This file defines the API for the core Kolibri app.
 * This file is automatically generated using the kolibri package.json
 * exports and exposes fields by the kolibri-build package.
 */

export default {
  'kolibri/apiResource': require('kolibri/apiResource'),
  'kolibri/apiResources/TaskResource': require('kolibri/apiResources/TaskResource'),
  'kolibri/client': require('kolibri/client'),
  'kolibri/components/AuthMessage': require('kolibri/components/AuthMessage'),
  'kolibri/components/Backdrop': require('kolibri/components/Backdrop'),
  'kolibri/components/BottomAppBar': require('kolibri/components/BottomAppBar'),
  'kolibri/components/CoreLogo': require('kolibri/components/CoreLogo'),
  'kolibri/components/CoreMenu': require('kolibri/components/CoreMenu'),
  'kolibri/components/CoreMenu/CoreMenuOption': require('kolibri/components/CoreMenu/CoreMenuOption'),
  'kolibri/components/CoreTable': require('kolibri/components/CoreTable'),
  'kolibri/components/DownloadButton': require('kolibri/components/DownloadButton'),
  'kolibri/components/FilterTextbox': require('kolibri/components/FilterTextbox'),
  'kolibri/components/GlobalSnackbar': require('kolibri/components/GlobalSnackbar'),
  'kolibri/components/PrivacyInfoModal': require('kolibri/components/PrivacyInfoModal'),
  'kolibri/components/SkipNavigationLink': require('kolibri/components/SkipNavigationLink'),
  'kolibri/components/SyncStatusDisplay': require('kolibri/components/SyncStatusDisplay'),
  'kolibri/components/error/AppError': require('kolibri/components/error/AppError'),
  'kolibri/components/error/ReportErrorModal': require('kolibri/components/error/ReportErrorModal'),
  'kolibri/components/error/TechnicalTextBlock': require('kolibri/components/error/TechnicalTextBlock'),
  'kolibri/components/language-switcher/LanguageSwitcherList': require('kolibri/components/language-switcher/LanguageSwitcherList'),
  'kolibri/components/language-switcher/LanguageSwitcherModal': require('kolibri/components/language-switcher/LanguageSwitcherModal'),
  'kolibri/components/onboarding/TooltipContent': require('kolibri/components/onboarding/TooltipContent'),
  'kolibri/components/onboarding/TooltipTour': require('kolibri/components/onboarding/TooltipTour'),
  'kolibri/components/pages/AppBarPage': require('kolibri/components/pages/AppBarPage'),
  'kolibri/components/pages/ImmersivePage': require('kolibri/components/pages/ImmersivePage'),
  'kolibri/components/pages/NotificationsRoot': require('kolibri/components/pages/NotificationsRoot'),
  'kolibri/components/pages/ScrollingHeader': require('kolibri/components/pages/ScrollingHeader'),
  'kolibri/composables/useContentViewer': require('kolibri/composables/useContentViewer'),
  'kolibri/composables/useFetch': require('kolibri/composables/useFetch'),
  'kolibri/composables/useMinimumKolibriVersion': require('kolibri/composables/useMinimumKolibriVersion'),
  'kolibri/composables/useNav': require('kolibri/composables/useNav'),
  'kolibri/composables/useNow': require('kolibri/composables/useNow'),
  'kolibri/composables/useSnackbar': require('kolibri/composables/useSnackbar'),
  'kolibri/composables/useTotalProgress': require('kolibri/composables/useTotalProgress'),
  'kolibri/composables/useTour': require('kolibri/composables/useTour'),
  'kolibri/composables/useUser': require('kolibri/composables/useUser'),
  'kolibri/composables/useUserSyncStatus': require('kolibri/composables/useUserSyncStatus'),
  'kolibri/constants': require('kolibri/constants'),
  'kolibri/heartbeat': require('kolibri/heartbeat'),
  'kolibri/router': require('kolibri/router'),
  'kolibri/rtlcss': require('kolibri/rtlcss'),
  'kolibri/styles/themeConfig': require('kolibri/styles/themeConfig'),
  'kolibri/uiText/bytesForHumans': require('kolibri/uiText/bytesForHumans'),
  'kolibri/uiText/commonCoreStrings': require('kolibri/uiText/commonCoreStrings'),
  'kolibri/uiText/kolibriOnboardingGuideStrings': require('kolibri/uiText/kolibriOnboardingGuideStrings'),
  'kolibri/uiText/licenses': require('kolibri/uiText/licenses'),
  'kolibri/uiText/notificationStrings': require('kolibri/uiText/notificationStrings'),
  'kolibri/urls': require('kolibri/urls'),
  'kolibri/utils/CatchErrors': require('kolibri/utils/CatchErrors'),
  'kolibri/utils/appError': require('kolibri/utils/appError'),
  'kolibri/utils/baseClient': require('kolibri/utils/baseClient'),
  'kolibri/utils/browserInfo': require('kolibri/utils/browserInfo'),
  'kolibri/utils/i18n': require('kolibri/utils/i18n'),
  'kolibri/utils/mimetypes': require('kolibri/utils/mimetypes'),
  'kolibri/utils/objectSpecs': require('kolibri/utils/objectSpecs'),
  'kolibri/utils/onboardingSteps': require('kolibri/utils/onboardingSteps'),
  'kolibri/utils/redirectBrowser': require('kolibri/utils/redirectBrowser'),
  'kolibri/utils/sanitizeError': require('kolibri/utils/sanitizeError'),
  'kolibri/utils/scriptLoader': require('kolibri/utils/scriptLoader'),
  'kolibri/utils/serverClock': require('kolibri/utils/serverClock'),
  'kolibri/utils/validators': require('kolibri/utils/validators'),
  'kolibri-logging': require('kolibri-logging'),
  vue: require('vue'),
};
